import { useCallback } from 'react';
import { downloadCSV, parseCSV } from '../../../utils/csv';
import { suggestedDosages as suggestedDosagesMapper } from '../../../utils/csv/mappers';
import { getSuggestedDosages, saveSuggestedDosage } from '../../../utils/storage/suggestedDosages';
import type { SuggestedDosage } from '../../../types/data';

export const useDosageImportExport = (onRefresh: () => void) => {
  const handleExport = useCallback(() => {
    const dosages = getSuggestedDosages();
    const columns = suggestedDosagesMapper.suggestedDosageHeaders.map(header => ({
      header,
      accessor: (item: SuggestedDosage) => suggestedDosagesMapper.toCSV(item)[header]
    }));
    
    downloadCSV(dosages, columns, 'suggested-dosages');
  }, []);

  const handleImport = useCallback(async (csvData: string) => {
    try {
      const parsed = await parseCSV(csvData);
      const imported = parsed.map(row => suggestedDosagesMapper.fromCSV(row));
      
      const validImports = imported.filter(item => {
        const isValid = item.name && typeof item.name === 'string';
        if (!isValid) {
          console.warn('Skipping invalid import item:', item);
        }
        return isValid;
      });

      if (validImports.length === 0) {
        throw new Error('No valid dosage data found in the imported file');
      }

      validImports.forEach(item => saveSuggestedDosage(item as SuggestedDosage));
      onRefresh();
    } catch (error) {
      console.error('Failed to import suggested dosages:', error);
      alert('Failed to import CSV file. Please check the file format and try again.');
    }
  }, [onRefresh]);

  return {
    handleExport,
    handleImport
  };
};